<template>
    <div class="main-block request-management">
        <div class="div col-12 p-0 d-flex align-items-start">
            <h4 class="">{{ $t("productServices.title") }}</h4>
        </div>
        <div class="col-12 mb-3 d-flex justify-content-end">
            <b-button variant="primary" @click="goToAddAddProductService">
                <i class="fas fa-plus mr-1"></i> {{ $t("productServices.create_title") }}
            </b-button>
        </div>
        <div class="col-12 row mt-3 m-0 p-0" style="min-height: 90%">
            <crud-table
                :columns="columns"
                :list-url="computedListUrl"
                ref="list-table"
                v-on:refresh="resetFilter"
            >
                <template #cell(actions)="{ item }">
                    <b-button variant="outline-primary" size="sm" @click="goToEditProductService(item.id)" class="mr-1">
                        <i class="fas fa-edit"></i>
                    </b-button>
                    <b-button
                        variant="outline-danger"
                        size="sm"
                        @click="handleDelete(item)"
                        :disabled="item.deleting"
                    >
                        <i class="fas fa-trash"></i>
                    </b-button>
                </template>
            </crud-table>
        </div>

        <!-- Delete Confirmation Modal -->
        <b-modal
            v-model="showDeleteModal"
            :title="$t('title.delete_confirmation')"
            @ok="confirmDelete"
            @cancel="cancelDelete"
            ok-variant="danger"
            cancel-variant="secondary"
            :ok-disabled="deleting"
        >
            <p>{{ $t('message.delete_confirmation') }}</p>
            <div v-if="deleting" class="text-center">
                <b-spinner small label="Deleting..."></b-spinner>
                <span class="ml-2">{{ $t('message.deleting') }}</span>
            </div>
        </b-modal>
    </div>
</template>

<script>
import { request } from "@/Util/Request";

const FILTER_FORM = {
    roles: null,
    statuses: null,
};

const COLUMN_STATE = (self) => [

    {
        key: "product.name",
        label: self.$t("products.title"),
        sortable: true,
    },
    {
        key: "service.title",
        label: self.$t("services.title"),
        sortable: true,
    },
    {
        key: "actions",
        label: self.$t("actions"),
    },
];

export default {
    data() {
        return {
            operation: "",
            query: {
                page: 1,
                perPage: 10,
            },
            pagination: {
                total: 0,
            },
            listUrl: "/get-users",
            filters: {
                ...FILTER_FORM,
            },
            showPopup: false,
            modalInstance: null,
            projects: [],
            showDeleteModal: false,
            itemToDelete: null,
            deleting: false,
        };
    },
    methods: {
        goToUserDetails(id) {
            this.$router.push({ name: "UsersInfo", params: { id } });
        },
        goToEditProductService(id) {
            this.$router.push({ name: "AdminProductServiceEdit", params: { id } });
        },
        handleDelete(item) {
            this.itemToDelete = item;
            this.showDeleteModal = true;
        },
        cancelDelete() {
            this.itemToDelete = null;
            this.showDeleteModal = false;
            this.deleting = false;
        },
        async confirmDelete() {
            if (!this.itemToDelete) return;

            this.deleting = true;
            try {
                await request({
                    method: "delete",
                    url: `/product-services/${this.itemToDelete.id}`,
                });

                this.$bvToast.toast(this.$t("message.delete_success"), {
                    title: this.$t("title.success"),
                    variant: "success",
                });

                this.refreshTable();
            } catch (error) {
                this.$bvToast.toast(this.$t("message.delete_error"), {
                    title: this.$t("title.error"),
                    variant: "danger",
                });
            } finally {
                this.cancelDelete();
            }
        },
        handleFilter() {
            this.$refs["list-table"].handleFilter(this.filters);
        },
        refreshTable() {
            this.$refs["list-table"].handleRefreshList();
        },
        resetFilter() {
            this.filters = {
                ...FILTER_FORM,
            };
        },
        goToAddAddProductService() {
            this.$router.push({ name: "AdminProductServiceCreate" });
        },
    },
    computed: {
        columns() {
            return COLUMN_STATE(this);
        },
        computedListUrl() {
            return  "/product-services";
        },
    },
};
</script>

<style scoped>
.ml-2 {
    margin-left: 0.5rem;
}
</style>
